import React from "react";
import "./InterviewQuestions.css";
import InterviewQuestionItem from "../components/InterviewQuestionItem";

function InterviewQuestions() {
  return (
    <div className="iq-container">
      <h1> QA Interview Questions</h1>
      <p className="iq-subtitle">
        Click on any question to reveal the answer.
      </p>

      {/* AUTOMATION */}
      <section>
        <h2>🤖 Automation Testing</h2>

        <InterviewQuestionItem
          question="What is Automation Testing?"
          answer="Automation testing uses tools and scripts to execute test cases automatically, reducing manual effort and increasing test coverage."
        />
        <InterviewQuestionItem
         question="What is Regression Testing?"
         answer="Regression testing ensures that new code changes do not break existing functionality."
        />
        <InterviewQuestionItem
        question="What is Hybrid Framework?"
        answer="A hybrid framework combines data-driven, keyword-driven, and modular testing approaches."
        />
        <InterviewQuestionItem
          question="What is Page Object Model (POM)?"
          answer="POM is a design pattern where each web page is represented as a class, improving code maintainability and reusability."
        />

        <InterviewQuestionItem
          question="Why is POM important?"
          answer="It separates test logic from UI locators, reducing duplication and making maintenance easier when UI changes."
        />

        <InterviewQuestionItem
         question="What is Selenium WebDriver?"
         answer="Selenium WebDriver is an open-source tool used to automate web browsers for functional testing."
        />

        <InterviewQuestionItem
        question="What is implicit wait in Selenium?"
        answer="Implicit wait tells WebDriver to wait for a specified time before throwing an exception if an element is not found."
        />

        <InterviewQuestionItem
        question="What is explicit wait?"
        answer="Explicit wait waits for a specific condition to occur before proceeding with the test execution."
        />

        <InterviewQuestionItem
        question="What is Fluent Wait?"
        answer="Fluent Wait allows polling at regular intervals and ignoring specific exceptions while waiting."
        />

        <InterviewQuestionItem
         question="What is Smoke Testing?"
         answer="Smoke testing verifies that the critical functionalities of an application work before deeper testing begins."
        />

        <InterviewQuestionItem
          question="What is MSTest?"
          answer="MSTest is a Microsoft testing framework used with .NET for unit and automation testing."
        />

        <InterviewQuestionItem
          question="Difference between implicit and explicit waits?"
          answer="Implicit wait applies globally, while explicit wait waits for a specific condition before proceeding."
        />
      </section>

      {/* API */}
      <section>
        <h2>🔗 API Testing</h2>

        <InterviewQuestionItem
          question="What is API testing?"
          answer="API testing validates business logic, data responses, and performance without relying on the UI."
        />

        <InterviewQuestionItem
          question="What are HTTP status codes?"
          answer="They indicate request results, such as 200 (success), 400 (bad request), 401 (unauthorized), and 500 (server error)."
        />

        <InterviewQuestionItem
          question="Difference between REST and SOAP?"
          answer="REST is lightweight and uses JSON, while SOAP is XML-based and more rigid with strict contracts."
        />

        <InterviewQuestionItem
         question="What is REST API?"
        answer="REST API is an architectural style that uses HTTP methods to access and manipulate resources."
        />

        <InterviewQuestionItem
          question="What is token-based authentication?"
          answer="It uses tokens (JWT, Bearer tokens) to authenticate users instead of session-based authentication."
        />

        <InterviewQuestionItem
          question="What tools are used for API testing?"
          answer="Common tools include Postman, RestAssured, SoapUI, and Newman."
        />

        <InterviewQuestionItem
          question="What are HTTP status codes?"
          answer="HTTP status codes indicate the result of an API request, such as 200 OK or 404 Not Found."
        />

        <InterviewQuestionItem
          question="What is token-based authentication?"
          answer="Token-based authentication uses a generated token to validate user identity for API requests."
        />

        <InterviewQuestionItem
          question="How do you test negative API scenarios?"
          answer="By sending invalid inputs, missing headers, expired tokens, or incorrect payload formats."
        />
      </section>

      {/* SDLC */}
      <section>
        <h2>📘 SDLC & QA Fundamentals</h2>

        <InterviewQuestionItem
          question="What is SDLC?"
          answer="SDLC is the Software Development Life Cycle, defining phases from requirement analysis to maintenance."
        />

        <InterviewQuestionItem
          question="What is branching in Git?"
          answer="Branching allows developers to work on features independently without affecting the main codebase."
        />

        <InterviewQuestionItem
          question="What is merge conflict?"
          answer="A merge conflict occurs when Git cannot automatically combine changes from different branches."
        />

        <InterviewQuestionItem
          question="What is Test Plan?"
          answer="A test plan outlines the testing strategy, scope, resources, and schedule."
        />

        <InterviewQuestionItem
          question="What is Test Case?"
          answer="A test case defines steps, inputs, and expected results to verify a feature."
        />

        <InterviewQuestionItem
          question="What is Severity vs Priority?"
           answer="Severity indicates impact of a defect, while priority indicates urgency to fix it."
        />

        <InterviewQuestionItem
          question="Difference between verification and validation?"
          answer="Verification checks if the product is built correctly; validation checks if the correct product is built."
        />

        <InterviewQuestionItem
          question="What is regression testing?"
          answer="Regression testing ensures that new changes do not break existing functionality."
        />

        <InterviewQuestionItem
          question="What is smoke testing?"
          answer="Smoke testing verifies basic functionality to ensure the build is stable for further testing."
        />

        <InterviewQuestionItem
          question="Difference between severity and priority?"
          answer="Severity indicates impact of a defect, while priority indicates urgency of fixing it."
        />
      </section>
    </div>
  );
}

export default InterviewQuestions;
